
import { brandingUrl } from 'hatchEndpoints';
export const LOGO_TYPE = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary'
};

/**
 * Branding Logo
 */
export default function FetchLogo( companyId, type = LOGO_TYPE.PRIMARY ) {

    return `${ brandingUrl }/companies/${ encodeURIComponent( companyId ) }/logos/${ encodeURIComponent( type ) }/deck`;

}
